import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { Problem } from "./components/sections/Problem";
import { WhatYouGet } from "./components/sections/WhatYouGet";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { RightForYou } from "./components/sections/RightForYou";
import { Volumes } from "./components/sections/Volumes";
import { Bonuses } from "./components/sections/Bonuses";
import { Included } from "./components/sections/Included";
import { Testimonials } from "./components/sections/Testimonials";
import { Offer } from "./components/sections/Offer";
import { Guarantee } from "./components/sections/Guarantee";
import { Author } from "./components/sections/Author";
import { Faq } from "./components/sections/Faq";
import { FinalCta } from "./components/sections/FinalCta";
import { Footer } from "./components/sections/Footer";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="3mlj6wpc9h30f">
      <MetaPixel data-id="element-1" data-mp="3mj6lg27aoaim" />
      <main data-id="element-2" data-mp="3rcj31sdk3h1v">
        <Hero data-id="element-3" data-mp="3rbzlwdvqcwow" />
        <Problem data-id="element-4" data-mp="3rdki07xp0nov" />
        <WhatYouGet data-id="element-5" data-mp="3rd1bdndhtlq5" />
        <BeforeAfter data-id="element-6" data-mp="3relu8fqg3g86" />
        <RightForYou data-id="element-7" data-mp="5os92t1uy7l" />
        <Volumes data-id="element-8" data-mp="4wvhonpuufq" />
        <Bonuses data-id="element-9" data-mp="5gel8p3rovc" />
        <Included data-id="element-10" data-mp="82ld64660ci" />
        <Testimonials data-id="element-11" data-mp="2zl3alhpbj03q" />
        <Offer data-id="element-12" data-mp="2zlld2w2kqak3" />
        <Guarantee data-id="element-13" data-mp="2zm4wyibsb90r" />
        <Author data-id="element-14" data-mp="2zmo5x9jgin2n" />
        <Faq data-id="element-15" data-mp="2zn6cayzu2hoa" />
        <FinalCta data-id="element-16" data-mp="33mov9p83gioh" />
      </main>
      <Footer data-id="element-17" data-mp="33lwzoeehyky7" />
      <FloatingCta anchorId="hero-cta" data-id="element-18" data-mp="33ngdzzglelxc" />
      <PurchasePopup data-id="element-19" data-mp="33oi1j3esp0vy" />
    </div>;
}